import React, { useEffect, useState, useRef, useCallback } from "react"
import { Button, Fab } from "@material-ui/core"
import * as flowNodeTypes from "./nodeTypes";
import { DialogNode } from "./";
import Swal from 'sweetalert2';
import * as edgeTypes from "./edgeTypes";
import { AddNodeIcon, CopyNodesIcon, PasteNodesIcon, PasteSpecialNodesIcon, useNodesClipboard } from "./";
import ReactFlow, {MiniMap,  Controls, useStoreActions, isNode } from 'react-flow-renderer';
import { resolveElement, resolveNodo, getLayoutedElements, resolveNodoRel, uuid } from "./HelperFunctions";
import { modesType } from "./DialogNode";
import { useDispatch } from "react-redux";
import abmActions from "../../../redux/actions/abm.actions";
import { useFlowContext } from "../../contexts/Flow";

const isEdge = (el) => el.source && el.target;

const itemStart = () => ({
  "id": uuid(),
  "position": {
    "x": 50,
    "y": 200
  },
  "type": "NodeStart",
  "data": {
    "nombre": "Inicio",
    "idTipo": 0,
    "tipoNodo": "NodeStart",
    "tipoNodoFuncional": "INICIO",
    "bgColor": "GREY",
    "fontColor": "WHITE",
    "fields": [],
    "idPrimitiva": null,
    "idTemplate": null,
    "descripcion": "",
    "label": ""
  }
})
export const Flow = ({ formik, onLoad, onSave, onClose }) => {

  const xPos = useRef(0);  
  const [ dialogState, setDialogState ] = useState({open: false});
  const [ nodeTypes, setNodeTypes ] = useState();
  const [ loading, setLoading ] = useState(true);
  const [ tiposConexiones, setTiposConexiones  ] = useState();
  const { flowData, setFlowData } = useFlowContext();
  const clipboard = useNodesClipboard();
  const divContainer = useRef();
  const setSelectedElements = useStoreActions((actions) => actions.setSelectedElements);

  const selectNode = (node) => {
    setSelectedElements([{id: node.id, type: node.type }]);
  };

  const dispatch = useDispatch();

  const [els, setElements] = useState([]);
  const [originalEls, setOriginalElements] = useState([]);

  //const undo = useUndo({objState: els, setter: setElements});
  
  useEffect(()=>{
    nodeTypesReload();
  }, [])

  const [selElements, setSelElements] = useState([]);

  useEffect(()=>{
    const container = divContainer.current.closest('div.MuiDialog-container');
    const handler = (event) => {
      if(container !== event.target) return;
      console.log(event.code)
      if(event.code === "KeyS" && (event.ctrlKey || event.metaKey)){
        setOriginalElements(JSON.stringify(els));
        onSave({close: false});
        event.preventDefault();
        return false;
      }
      if(event.code === "KeyQ" && (event.ctrlKey || event.metaKey)){
        onClose();
        event.preventDefault();
        return false;
      }
      if(event.code === "Delete"){
        removeSelectedNodes();
        event.preventDefault();
        return false;
      }
    };
    document.addEventListener('keydown', handler);
    return ()=>document.removeEventListener('keydown', handler)
  }, [onSave, onClose, selElements])
  
  const nodeTypesReload = () => {
    const getNodeTypes = () => dispatch(abmActions().getNodeTypes());
    const getConectionTypes = () => dispatch(abmActions().getConectionTypes());
    return new Promise((resolve, reject) => {
      getConectionTypes()
        .then(newTiposConexiones => {
          getNodeTypes()
            .then(newNodeTypes => {
              setTiposConexiones(newTiposConexiones.fields)
              setNodeTypes(newNodeTypes.value);
              resolve();
            })
            .catch(err => {
              reject(err);
            })
        })       
        .catch(err => {
          reject(err);
        });

    })
  }

  const abmPrimitiva = (event, id = 0) => {
    const isNew = id === 0;
    event && event.preventDefault();
    setDialogState({
      open: true,
      caption: isNew ? "Agregar nueva primitiva" : "Editar primitiva",
      onSubmit: (values, data) => {
        if(isNew){
          abmPrimitiva(null, values.id)
        }else{
          nodeTypesReload().then(()=>{
            addNode();
          });
        }
      },
      type: "Primitiva",
      data: {
        id
      },
      maxWidth: "md",
      mode: modesType.DRAWER,
      HeaderAction: undefined,
      DialogAction: ()=><></>
    });
  }

  const abmTemplate = (event, id = 0) => {
    const isNew = id === 0;
    event && event.preventDefault();
    setDialogState({
      open: true,
      caption: isNew ? "Agregar nuevo template" : "Editar template",
      onSubmit: (values, data) => {
        if(isNew){
          abmTemplate(null, values.id)
        }else{
          nodeTypesReload().then(()=>{
            addNode();
          });
        }
      },
      type: "Template",
      data: {
        id
      },
      maxWidth: "md",
      mode: modesType.DRAWER,
      HeaderAction: undefined,
      DialogAction: ()=><></>
    });
  }

  useEffect(()=>{
    if(tiposConexiones && formik && formik.values && formik.values.id && formik.values.id !== 0){
      const getFlow = (idOperacion) => dispatch(abmActions().getFlow(idOperacion));
      setLoading(true);
      getFlow(formik.values.id)
        .then(response =>{
          const newElements = response.map(el => resolveElement({el: isEdge(el) ? {...el, data: { ...el.data, color: tiposConexiones.find(x => x.value === el.data.tipoConexion).color} } : el, onEdit: editNode, onRemove: removeNode, onEdgeEdit: handleEdgeDoubleClick}));
          const newElementsWithStart = newElements.some(elem => elem.type === "NodeStart") 
            ? newElements 
            : newElements && [...newElements, resolveElement({el: itemStart(), onEdit: editNode, onRemove: removeNode, onEdgeEdit: handleEdgeDoubleClick})];
          setElements(newElementsWithStart);
          setOriginalElements(JSON.stringify(newElementsWithStart));
        })
        .catch(error => {

        })
        .finally(()=>{
          setLoading(false);
          onLoad();
          setTimeout(flowData.fit, 500) 
        });
    }      
  }, [tiposConexiones])

  const removeNode = useCallback(({id, data}) => {
    if(!id) return;
    const itemDescription = data.label;
    Swal
      .fire({
        icon: 'question',
        title: 'Eliminar nodo',
        html: `Está seguro de eliminar este nodo?<br/> <span>${itemDescription}</span>`,
        showCancelButton: true,
        confirmButtonText: 'Eliminar',
        cancelButtonText: 'Cerrar',
      })
      .then((result) => {
        if (result.isConfirmed) {
          setElements((els) => els.filter(x => x.id !== id && x.source !==id && x.target !==id));
        }
      })
  }, []);

  const handleDialogClose = useCallback(() => {
    setDialogState({open: false, onDeleteClick: null})
  }, []);

  const handleDialogLoadTxtSubmit = useCallback( ({node, data}) => {
    setDialogState({open: false});
    const elements = !data.code ? [] : (Array.isArray(data.code) ? data.code : JSON.parse(data.code));
    //const menorId = elements.filter(x => !isNaN(x.id)).map(x => parseInt(x.id, 10)).reduce((prev, cur) => Math.min(prev, cur), 0);
    //setNextId(menorId-1)
    setElements(elements.map(el => resolveElement({el, onEdit: editNode, onRemove: removeNode, onEdgeEdit: handleEdgeDoubleClick})));
  }, [handleEdgeDoubleClick, removeNode, editNode]);

  useEffect(()=>{
    if(dialogState.type === "AddNode") {
      setDialogState(dialogState => ({...dialogState, formData: {nodeTypes}}));
    }
  }, [nodeTypes, dialogState.type])

  const addNode = () => {
    xPos.current += 50;
      setDialogState(dialogState => ({
        open: true,
        caption: "Agregar nodo",
        onSubmit: (values, data) => {
          confirmAddNode(values)
        },
        type: "AddNode",
        data: {
        },
        maxWidth: "lg",
        mode: modesType.DIALOG,
        formData: {
          nodeTypes
        },
        HeaderAction: () => <><Button onClick={e=>abmPrimitiva(e)}>agregar primitiva</Button><Button onClick={e=>abmTemplate(e)}>agregar template</Button></>,
        showConfirm: false,
      }));
  };

  const confirmAddNode = (node) => {

    const els = flowData.get();
    
    /*
    try{
      const minX = els.reduce((prev, curr) => (curr.position && (curr.position.x < prev)) ? curr.position.x : prev, Number.MAX_SAFE_INTEGER);
      const maxX = els.reduce((prev, curr) => (curr.position && (curr.position.x > prev)) ? curr.position.x : prev, Number.MIN_SAFE_INTEGER);
      x = ((maxX === Number.MIN_SAFE_INTEGER ? 0 : maxX) - (minX === Number.MAX_SAFE_INTEGER ? 0 : minX) / 2) + (minX === Number.MAX_SAFE_INTEGER ? 0 : minX)
      const maxY = els.reduce((prev, curr) => (curr.position && (curr.position.y > prev)) ? curr.position.y : prev, Number.MIN_SAFE_INTEGER);
      y = (maxY === Number.MIN_SAFE_INTEGER ? 0 : maxY) + 50;
    }catch(e){}
    */
   
    const maxY = els.map(e => isNode(e) ? e.position.y : Number.MIN_SAFE_INTEGER).sort((a, b) => b - a)[0];
    const minX = els.map(e => isNode(e) ? e.position.x : Number.MAX_SAFE_INTEGER).sort((a, b) => a - b)[0];
    
    setDialogState(dialogState => ({
      open: true,
      caption: <>Agregar nodo: {node._tipo.nombre}</>,
      onSubmit: (values, data) => {
        const newNodo = resolveNodo({          
          xPos: minX+100, 
          yPos: maxY+100,
          type: values.tipoNodo, 
          data: values, 
          onEdit: editNode, 
          onRemove: removeNode
        });
        setDialogState({open: false});
        setElements((els) => [newNodo, ...els ? els : []]);
        selectNode(newNodo);
      },
      data: {
        ...node
      },
      formData : {
        parent: formik.values
      },
      type: node.tipoNodo,
      mode: modesType.DRAWER,
      maxWidth: "md",
    }));
  };

  const editNode = (node) => {
    setDialogState(dialogState => ({
      open: true,
      caption: `Editar nodo: ${node.data.nombreOriginal}`,
      onSubmit: (values, data) => {
        setElements(elements => elements.map(node => 
          node.id === values.id 
          ? {...node, data: values} 
          : node
        ));
        setDialogState({open: false});
      },
      data: {id: node.id, ...node.data},
      formData : {
        parent: formik.values
      },
      type: node.type,
      mode: modesType.DRAWER,

    }));
  };
  
  const orderNodes = useCallback(() => {
    const elements = getLayoutedElements(els)
    setElements(elements.map(el => resolveElement({el, onEdit: editNode, onRemove: removeNode, onEdgeEdit: handleEdgeDoubleClick})));
  }, [els, editNode, removeNode, handleEdgeDoubleClick])

  const addEdge = useCallback(({ source, target, sourceHandle, targetHandle }) => {
    const tipoConexion = tiposConexiones.find(x => x.value === "DIRECTA");

    setElements((els) => {
        return [...els.filter(x => !(x.source === source && x.target === target)), resolveNodoRel(target, source, sourceHandle, "", handleEdgeDoubleClick, {etiqueta: "Directa", tipoConexion: tipoConexion.value, color: tipoConexion.color})]
    });
  }, [tiposConexiones]);

  const deleteEdge = useCallback(({id, etiqueta}) => {

    return new Promise((resolve, reject) => {
      Swal
        .fire({
          icon: 'question',
          title: 'Eliminar conexión',
          html: `Está seguro de eliminar esta conexión?<br/> <span>${etiqueta}</span>`,
          showCancelButton: true,
          confirmButtonText: 'Eliminar',
          cancelButtonText: 'Cerrar',
        })
        .then((result) => {
          if (result.isConfirmed) {
            setElements((els) => els.filter(x => x.id !== id));
            resolve();
          }else{
            reject();
          }
        })
    });
  }, []);

  const handleEdgeDoubleClick = useCallback((event, edge) => {
    setElements(els => {
      const edgeElement = els.find(x => x.id === edge.id);
      setDialogState(dialogState => ({
        open: true,
        caption: "Editar conexión",
        onSubmit: (values) => {
          setDialogState({open: false});
          setElements( els => els.map(el => 
            el.id === values.id 
              ? resolveNodoRel(
                  values.salida, 
                  el.source, 
                  el.sourceHandle, 
                  "", 
                  handleEdgeDoubleClick,
                  values,
                )
              : el
          ));
        },
        type: "EdgeEdit",
        data: {
          ...edgeElement.data,
          id: edgeElement.id,
          salida: edgeElement.target
        },
        formData: {
          tiposConexiones,
          parent: formik.values
        },
        mode: modesType.DRAWER,
        onDeleteClick: deleteEdge
      }));
      return els;

    })
  }, [tiposConexiones]);

 

  const handleSelect = (elements) => {
    setSelElements(elements);
  }

  const removeSelectedNodes = () => {
    if(!selElements || selElements.length === 0) return;
    Swal
      .fire({
        icon: 'question',
        title: 'Eliminar selección de nodos',
        html: `Está seguro de eliminar los nodos seleccionados?`,
        showCancelButton: true,
        confirmButtonText: 'Eliminar',
        cancelButtonText: 'Cerrar',
      })
      .then((result) => {
        if (result.isConfirmed) {
          setElements((els) => els.filter(x => {
            return !selElements.some(sel => sel.id === x.id)
          }));
        }
      })
  }

  const handleCopyNodes = () => {
    clipboard.flowToClipboard({elements: selElements, flowName: formik.values.nombre});
  }

  const handlePasteNodes = () => {
    clipboard.getFlow().then(flow => {
      setElements(els => 
        clipboard.pasteFlowIntoElements({
          flow, 
          elements: els, 
          resolveElement: (el) => resolveElement({el, onEdit: editNode, onRemove: removeNode, onEdgeEdit: handleEdgeDoubleClick})
        })
      );
    })
  }

  const handlePasteSpecialNodes = () => {
    clipboard.getFlow({
      replaces: [
        {searchValue: (flow) => flow.flowName, replaceValue: formik.values.nombre}
      ]
    }).then(flow => {
      setElements(els => 
        clipboard.pasteFlowIntoElements({
          flow, 
          elements: els, 
          resolveElement: (el) => resolveElement({el, onEdit: editNode, onRemove: removeNode, onEdgeEdit: handleEdgeDoubleClick})
        })
      );
    })
  }

  useEffect(()=>{
    const isChanged = JSON.stringify(els) !== originalEls;
    setFlowData(prev => ({...prev, isChanged }))
  }, [els, originalEls]);

  return (
    <> 
      <DialogNode 
        onClose={handleDialogClose} 
        {...dialogState}
      />
      <div ref={divContainer} style={{ height: "100%", backgroundColor: "transparent" }}>

        {loading && 
          <div 
            class="spinner-border color-highlight"
            style={{
              marginLeft: "50%",
              marginTop: 300,
              zIndex: 900000,
              position: "absolute",
            }}
            role="status"></div>
        }
        <Fab  onClick={addNode} 
          sx={{ position: 'absolute', top: 60, left: 26, zIndex: 9000 }}  
        >
          <AddNodeIcon/> 
        </Fab>
        <Fab  onClick={handleCopyNodes} 
          sx={{ position: 'absolute', top: 60, left: 86, zIndex: 9000 }}  
        >
          <CopyNodesIcon/> 
        </Fab>
        <Fab  onClick={handlePasteNodes} 
          sx={{ position: 'absolute', top: 60, left: 146, zIndex: 9000 }} 
        >
          <PasteNodesIcon/> 
        </Fab>        
        <Fab  onClick={handlePasteSpecialNodes} 
          sx={{ position: 'absolute', top: 60, left: 206, zIndex: 9000 }} 
        >
          <PasteSpecialNodesIcon/> 
        </Fab>
        <ReactFlow
          nodeTypes={flowNodeTypes}
          elements={els}
          onElementsRemove={removeNode}
          onConnect={addEdge}
          onEdgeDoubleClick={handleEdgeDoubleClick}
          edgeTypes={edgeTypes}
          onSelectionChange={handleSelect}
          onLoad={(instance)=>{
            setFlowData({
              isChanged: false,
              project: ()=>instance.project(),
              get: ()=>instance.getElements(),
              fit: ()=>{
                instance.fitView({ padding: 0.25, includeHiddenNodes: false })
              },
            })
          }}
        >
          <MiniMap
            nodeStrokeColor={(n) => {
              const color = (n.data && n.data.bgColor)
                || (n.type === 'NodeSticky' 
                  ?  "#f9f967" 
                  : '#ededed');
              return color;
            }}
            nodeColor={(n) => {
              const color = (n.data && n.data.bgColor)
                || (n.type === 'NodeSticky' 
                  ?  "#f9f967" 
                  : '#ededed');
              return color;
            }}
            nodeBorderRadius={2}
          />


          <Controls />
        </ReactFlow>
      </div>

    </>
  );
}
